import type { Form } from 'factorial-form'
import { TerminatePageEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  form: Form
  employee: TerminatePageEmployeeFragment
}

const ReassignManagerSelect = ({ form, employee }: Props) => {
  const getLabel = () =>
    !!employee.reportsConnection.nodes.length
      ? i18n.t('employee_form.reassign_reports_to')
      : i18n.t('employee_form.reassign_to')

  const managerField = form.get('manager_id')
  const selectedManagerId = managerField.value

  return (
    <>
      <EmployeeSelectorV2
        label={getLabel()}
        forcedFilters={{
          includeInactive: false,
          excludeCurrentEmployee: true,
          withActiveContract: true,
        }}
        value={Number(selectedManagerId)}
        onChange={(newManagerId) => {
          managerField.set(newManagerId)
        }}
      />
    </>
  )
}

export default observer(ReassignManagerSelect)
